var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-badge',{attrs:{"color":"error","overlap":"","content":_vm.activeAlarmsText}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(" mdi-alert-outline")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }